const mainConfig = {
  version: '0.0.1',
  baseURL: process.env.REACT_APP_DOMAIN || '/',
  serviceBaseURL: `${process.env.REACT_APP_API_ENDPOINT || ''}/api/`,
};

export default mainConfig;
